import { ExternalLink, Truncate } from '@labrav/react-components'
import { Typography } from '@mui/material'

import { useStyles } from './ResponsiveColumn.styles'

export type ResponsiveColumnProps = {
  linkText: string | JSX.Element
  linkUrl?: string
  maxWidth?: string
  descText?: string | JSX.Element
  otherElement?: JSX.Element
}

export const ResponsiveColumn = ({
  linkText,
  linkUrl,
  maxWidth,
  descText,
  otherElement,
}: ResponsiveColumnProps) => {
  const withUrl = !!linkUrl
  const { classes } = useStyles()
  return (
    <>
      <div className={classes.container}>
        <Truncate style={{ maxWidth }} clipboardTooltip>
          {linkText}
        </Truncate>
        {withUrl && <ExternalLink children={<></>} href={linkUrl} />}
        {otherElement}
      </div>
      {descText && (
        <Typography className={classes.subRowText} style={{ maxWidth }}>
          {descText}
        </Typography>
      )}
    </>
  )
}
